<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section">
            <v-container>
                <tit-primary :sc="`${type} SUPPORT`" :tit="title"> </tit-primary>

                <router-view name="service-application"></router-view>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import { SERVICE_PROGRAM_CATEGORIES } from "@/assets/variables";

import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";

export default {
    components: {
        SubVisual,
        ClientPage,
        TitPrimary,
        MypageNavigation,
    },
    props: {
        category: { type: String, default: SERVICE_PROGRAM_CATEGORIES.UNIT.value.toLowerCase() },
    },
    computed: {
        title() {
            return SERVICE_PROGRAM_CATEGORIES[this.category?.toUpperCase?.()]?.text || null;
        },
        type() {
            return SERVICE_PROGRAM_CATEGORIES[this.category?.toUpperCase?.()]?.value || null;
        },

        accessToken() {
            return this.$store.state.accessToken;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init: function () {
            if (!this.accessToken) {
                this.$router.push("/login");
            }
        },
    },
};
</script>
